import { stringArrayToObject } from '~utils/array';
import { TOPICS } from '~constants/content';

import energyImage from './assets/ic_proyectos_energy_pin.svg';
import energyImageSelected from './assets/ic_proyectos_energy_pin_seleccionado.svg';
import transportImage from './assets/ic_proyectos_truck_pin.svg';
import transportImageSelected from './assets/ic_proyectos_truck_pin_seleccionado.svg';
import boundaryImage from './assets/ic_proyectos_borders_pin.svg';
import boundaryImageSelected from './assets/ic_proyectos_borders_pin_seleccionado.svg';
import communicationsImage from './assets/ic_proyectos_communication_pin.svg';
import communicationsImageSelected from './assets/ic_proyectos_communication_pin_seleccionado.svg';
import aereoImage from './assets/ic_proyectos_aereo_pin.svg';
import aereoImageSelected from './assets/ic_proyectos_aereo_pin_seleccionado.svg';
import carreteroImage from './assets/ic_proyectos_carretero_pin.svg';
import carreteroImageSelected from './assets/ic_proyectos_carretero_pin_seleccionado.svg';
import ferroviarioImage from './assets/ic_proyectos_ferroviario_pin.svg';
import ferroviarioImageSelected from './assets/ic_proyectos_ferroviario_pin_seleccionado.svg';
import fluvialImage from './assets/ic_proyectos_fluvial_pin.svg';
import fluvialImageSelected from './assets/ic_proyectos_fluvial_pin_seleccionado.svg';
import maritimoImage from './assets/ic_proyectos_maritimo_pin.svg';
import maritimoImageSelected from './assets/ic_proyectos_maritimo_pin_seleccionado.svg';
import multimodalImage from './assets/ic_proyectos_multimodal_pin.svg';
import multimodalImageSelected from './assets/ic_proyectos_multimodal_pin_seleccionado.svg';

export const MARKER_WIDTH = 42;
export const MARKER_HEIGHT = 46;
export const MARKER_OFFSET_HORIZONTAL = 2;
export const MARKER_OFFSET_VERTICAL = -6;

interface IconMap {
  [key: string]: any;
}

export const TRANSPORT_SUBSECTORS_LIST = ['Aéreo', 'Carretero', 'Fluvial', 'Marítimo', 'Ferroviario'];
export const TRANSPORT_SUBSECTORS = stringArrayToObject(TRANSPORT_SUBSECTORS_LIST);

export const MARKER_IMAGE: IconMap = {
  [TOPICS.energy]: energyImage,
  [TOPICS.transport]: transportImage,
  [TOPICS.boundary]: boundaryImage,
  [TOPICS.telecommunications]: communicationsImage,
  [TRANSPORT_SUBSECTORS.Aéreo]: aereoImage,
  [TRANSPORT_SUBSECTORS.Carretero]: carreteroImage,
  [TRANSPORT_SUBSECTORS.Ferroviario]: ferroviarioImage,
  [TRANSPORT_SUBSECTORS.Fluvial]: fluvialImage,
  [TRANSPORT_SUBSECTORS.Maritimo]: maritimoImage,
  [TRANSPORT_SUBSECTORS.Multimodal]: multimodalImage,
  'transporte aéreo': aereoImage,
  'transporte aereo': aereoImage,
  'transporte carretero': carreteroImage,
  'transporte ferroviario': ferroviarioImage,
  'transporte fluvial': fluvialImage,
  'transporte marítimo': maritimoImage,
  'transporte maritimo': maritimoImage,
  'transporte multimodal': multimodalImage,
  'energía': energyImage,
  'energia': energyImage,
  'transporte': transportImage,
  'telecomunicaciones': communicationsImage,
  'comunicaciones': communicationsImage,
  'comercio': transportImage,
  'producción': transportImage,
  'produccion': transportImage,
  'infraestructura': carreteroImage,
  'medio ambiente': multimodalImage,
  'social': multimodalImage,
  '': multimodalImage,
};

export const MARKER_IMAGE_SELECTED: IconMap = {
  [TOPICS.energy]: energyImageSelected,
  [TOPICS.transport]: transportImageSelected,
  [TOPICS.boundary]: boundaryImageSelected,
  [TOPICS.telecommunications]: communicationsImageSelected,
  [TRANSPORT_SUBSECTORS.Aéreo]: aereoImageSelected,
  [TRANSPORT_SUBSECTORS.Carretero]: carreteroImageSelected,
  [TRANSPORT_SUBSECTORS.Ferroviario]: ferroviarioImageSelected,
  [TRANSPORT_SUBSECTORS.Fluvial]: fluvialImageSelected,
  [TRANSPORT_SUBSECTORS.Maritimo]: maritimoImageSelected,
  [TRANSPORT_SUBSECTORS.Multimodal]: multimodalImageSelected,
  'transporte aéreo': aereoImageSelected,
  'transporte aereo': aereoImageSelected,
  'transporte carretero': carreteroImageSelected,
  'transporte ferroviario': ferroviarioImageSelected,
  'transporte fluvial': fluvialImageSelected,
  'transporte marítimo': maritimoImageSelected,
  'transporte maritimo': maritimoImageSelected,
  'transporte multimodal': multimodalImageSelected,
  'energía': energyImageSelected,
  'energia': energyImageSelected,
  'transporte': transportImageSelected,
  'telecomunicaciones': communicationsImageSelected,
  'comunicaciones': communicationsImageSelected,
  'comercio': transportImageSelected,
  'producción': transportImageSelected,
  'produccion': transportImageSelected,
  'infraestructura': carreteroImageSelected,
  'medio ambiente': multimodalImageSelected,
  'social': multimodalImageSelected,
  '': multimodalImageSelected,
};

export const getMarkerImage = (topic: string, selected: boolean) => {
  const icon = selected ? MARKER_IMAGE_SELECTED[topic] : MARKER_IMAGE[topic];
  if (!icon) {
    return selected ? MARKER_IMAGE_SELECTED[''] : MARKER_IMAGE[''];
  }
  return icon;
}
